export let ItemType = /*#__PURE__*/function (ItemType) {
  ItemType["Item"] = "item";
  ItemType["ItemScheduled"] = "item-scheduled";
  ItemType["ItemLive"] = "item-live";
  ItemType["ItemLiveFinalize"] = "item-live-finalize";
  return ItemType;
}({});
//# sourceMappingURL=item-type.js.map